<ng-container *ngIf="!isMobileDrawerOpened">
  <!-- Botão flutuante centralizado na parte de baixo -->
  <button class="ai-agent-fab" *ngIf="this.view === viewMode.FAB" (click)="openInput()" [ngClass]="getPositionClass()" data-tour-id="ai-agent-fab">
    <app-ai-agent-avatar state="idle" size="sm" variant="fab"></app-ai-agent-avatar>
  </button>

  <!-- Input animado -->
  <div class="ai-agent-input-wrapper" [class.open]="this.view !== viewMode.FAB" [ngClass]="getPositionClass()" data-tour-id="ai-agent-panel">
    <ng-container *ngIf="this.view !== viewMode.FAB">
    <!-- Chat -->
    <div class="card card-stats border shadow">
      <div class="card-header border-bottom m-2 p-2 d-flex justify-content-between align-items-center ai-agent-header" data-tour-id="ai-agent-header">
        <div class="ai-agent-header-title" data-tour-id="ai-agent-title">
          <input #chatTitleInput
                 *ngIf="isEditingChatTitle; else chatTitleTemplate"
                 type="text"
                 class="form-control form-control-sm ai-agent-title-input"
                 [(ngModel)]="editingChatTitle"
                 [attr.maxlength]="chatTitleMaxLength"
                 (keydown.enter)="$event.preventDefault(); saveChatTitle()"
                 (keydown.escape)="cancelChatTitleEdit()"
                 (blur)="saveChatTitle()"
                 [disabled]="isSavingChatTitle">
          <ng-template #chatTitleTemplate>
            <button *ngIf="canEditSelectedChatTitle(); else defaultHeaderTitle"
                    type="button"
                    class="btn btn-link p-0 ai-agent-title-button"
                    [title]="getHeaderTitle()"
                    (click)="startChatTitleEdit()">
              <span class="text-uppercase text-muted text-truncate">{{ getHeaderTitle() }}</span>
              <i class="fa-solid fa-pen ai-agent-title-icon" aria-hidden="true"></i>
            </button>
            <ng-template #defaultHeaderTitle>
              <h5 class="card-title text-uppercase text-muted mb-0 text-truncate"
                  [title]="getHeaderTitle()">{{ getHeaderTitle() }}</h5>
            </ng-template>
          </ng-template>
        </div>
        <div class="d-flex flex-row justify-content-end align-items-center">
          <button class="btn btn-sm btn-link p-0 ml-2" data-tour-id="ai-agent-history-toggle" [matTooltip]="(this.view !== viewMode.HISTORY ? 'ai.agent.actions.show_history' : 'ai.agent.actions.show_chat') | translate"
                  (click)="toggleChats()">
            <i class="fa-solid fa-bars" *ngIf="this.view !== viewMode.HISTORY"></i>
            <i class="fa-solid fa-comment" *ngIf="this.view === viewMode.HISTORY"></i>
          </button>
          <button class="btn btn-sm btn-link p-0 ml-2" data-tour-id="ai-agent-close" [matTooltip]="'ai.agent.actions.close' | translate"
                  (click)="close()">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
      </div>

      <div class="ai-agent-preview p-5" data-tour-id="ai-agent-preview" *ngIf="this.view !== viewMode.HISTORY && chatQuestions.length === 0">
        <div class="ai-agent-watermark">
          <app-ai-agent-avatar state="idle" size="xl" variant="watermark"></app-ai-agent-avatar>
        </div>
        <p class="text-center text-muted mt-3">Informamos que os dados submetidos serão processados por inteligência
          artificial. Por favor, evite enviar informações confidenciais ou sensíveis sem o devido consentimento.</p>
        <p class="text-center text-muted mt-2">A IA pode cometer erros. Considere verificar informações importantes.</p>
      </div>

      <div class="card-body" *ngIf="this.view !== viewMode.HISTORY && chatQuestions.length > 0 && this.actualStep === 0">
        <div class="row">
          <section class="chat" #chat>
            <div class="messages-chat" data-tour-id="ai-agent-messages">
              <ng-container *ngFor="let question of chatQuestions; let questionIndex = index; trackBy: trackByQuestion">
                <div class="message">
                  <div class="ai-agent-message-attachments" data-tour-id="ai-agent-message-attachments" *ngIf="getQuestionAttachments(question).length">
                    <div class="ai-agent-attachment-card"
                         *ngFor="let attachment of getQuestionAttachments(question); trackBy: trackByAttachment"
                         data-tour-id="ai-agent-message-attachment"
                         [ngClass]="getAttachmentStateClass(attachment)">
                      <div class="ai-agent-attachment-card__icon">
                        <i [class]="getAttachmentIconClass(attachment)" aria-hidden="true"></i>
                      </div>
                      <div class="ai-agent-attachment-card__content">
                        <div class="ai-agent-attachment-card__header">
                          <span class="ai-agent-attachment-card__name">{{ attachment.fileName }}</span>
                          <span class="ai-agent-attachment-card__badge">{{ getAttachmentStateLabel(attachment) }}</span>
                        </div>
                        <div class="ai-agent-attachment-card__meta">
                          <span>{{ getAttachmentKindLabel(attachment.kind) }}</span>
                          <span>•</span>
                          <span>{{ formatAttachmentSize(attachment.size) }}</span>
                          <ng-container *ngIf="attachment.stage">
                            <span>•</span>
                            <span>{{ getAttachmentStageLabel(attachment.stage) }}</span>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p class="text">{{ question.question }}</p>
                </div>
                <div class="message">
                  <div class="ai-agent-response-row"
                       [class.ai-agent-response-row-thinking]="isPendingQuestion(questionIndex)">
                    <app-ai-agent-avatar class="ai-agent-response-avatar"
                                         *ngIf="!isPendingQuestion(questionIndex)"
                                         [state]="getQuestionAvatarState(question, questionIndex)"
                                         size="sm"></app-ai-agent-avatar>
                    <div class="response ai-agent-response-panel" data-tour-id="ai-agent-response">
                    <ng-container *ngIf="question.content; else typingTemplate">
                      <ng-container *ngIf="isLoopContract(question.content); else legacyResponseTemplate">
                        <div class="ai-agent-loop-card" [attr.data-state]="getLoopVisualState(question.content)">
                          <div class="text" *ngIf="question.content.message">
                            <app-markdown-viewer [data]="question.content.message"></app-markdown-viewer>
                          </div>
                          <div class="ai-agent-loop-summary" *ngIf="getLoopSummary(question.content) as loopSummary">
                            <div class="ai-agent-loop-section-label">{{ getLoopSummaryLabel(question.content) }}</div>
                            <div class="ai-agent-loop-section-text">{{ loopSummary }}</div>
                          </div>
                          <div class="ai-agent-guided-actions" *ngIf="hasGuidedActions(question.content)">
                            <div class="ai-agent-loop-section-label">{{ "ai.agent.actions.guided_list.title" | translate }}</div>
                            <div class="ai-agent-guided-action"
                                 *ngFor="let action of getGuidedActions(question.content); let actionIndex = index; trackBy: trackByGuidedAction">
                              <i class="fa-solid fa-route text-primary" aria-hidden="true"></i>
                              <div class="ai-agent-guided-action-copy">
                                <div class="ai-agent-guided-action-title">{{ getGuidedActionTitle(action, actionIndex) }}</div>
                                <div class="ai-agent-guided-action-fields" *ngIf="action.fields?.length">
                                  <span class="ai-agent-guided-action-field"
                                        *ngFor="let field of action.fields; trackBy: trackByAgentField">
                                    {{ field.name }}<ng-container *ngIf="field.value">: {{ field.value }}</ng-container>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="ai-agent-loop-plan" *ngIf="hasLoopPlanItems(question.content)">
                            <div class="ai-agent-loop-plan-label">{{ "ai.agent.loop.plan" | translate }}</div>
                            <div class="ai-agent-loop-plan-item"
                                 *ngFor="let item of getLoopPlanItems(question.content)"
                                 [attr.data-status]="item.status">
                              <i [className]="getPlanItemIconClass(item)" aria-hidden="true"></i>
                              <div class="ai-agent-loop-plan-copy">
                                <div class="small">
                                  <span>{{ getPlanItemTitle(item) }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="text text-warning mt-2" *ngIf="question.content.error && getLoopVisualState(question.content) === 'error'">
                            {{ question.content.error }}
                          </div>
                          <div class="text-center mt-3" *ngIf="canConfirmPlan(question.content, questionIndex) || shouldShowGuidedStart(question.content)">
                            <button class="btn btn-sm btn-success mt-1 mr-2"
                                    *ngIf="canConfirmPlan(question.content, questionIndex)"
                                    (click)="confirmPlan(question.content, questionIndex)">{{ "ai.agent.actions.confirm" | translate }}
                            </button>
                            <button class="btn btn-sm btn-outline-secondary mt-1"
                                    *ngIf="canConfirmPlan(question.content, questionIndex)"
                                    (click)="cancelPlan(question.content, questionIndex)">{{ "ai.agent.actions.cancel" | translate }}
                            </button>
                            <button class="btn btn-sm btn-primary mt-1"
                                    [class.ml-4]="canConfirmPlan(question.content, questionIndex)"
                                    *ngIf="shouldShowGuidedStart(question.content)"
                                    (click)="startStep(question.content)">{{ "ai.agent.actions.start" | translate }}
                            </button>
                          </div>
                        </div>
                      </ng-container>
                      <ng-template #legacyResponseTemplate>
                        <div class="text" *ngIf="!question.content.error">
                          <app-markdown-viewer [data]="question.content.message"></app-markdown-viewer>
                          <div class="ai-agent-guided-actions" *ngIf="hasGuidedActions(question.content)">
                            <div class="ai-agent-loop-section-label">{{ "ai.agent.actions.guided_list.title" | translate }}</div>
                            <div class="ai-agent-guided-action"
                                 *ngFor="let action of getGuidedActions(question.content); let actionIndex = index; trackBy: trackByGuidedAction">
                              <i class="fa-solid fa-route text-primary" aria-hidden="true"></i>
                              <div class="ai-agent-guided-action-copy">
                                <div class="ai-agent-guided-action-title">{{ getGuidedActionTitle(action, actionIndex) }}</div>
                                <div class="ai-agent-guided-action-fields" *ngIf="action.fields?.length">
                                  <span class="ai-agent-guided-action-field"
                                        *ngFor="let field of action.fields; trackBy: trackByAgentField">
                                    {{ field.name }}<ng-container *ngIf="field.value">: {{ field.value }}</ng-container>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="text-center">
                            <button class="btn btn-sm btn-primary mt-1"
                                    *ngIf="shouldShowExecute(question.content)"
                                    (click)="aiExecute(question.content)">{{ "ai.agent.actions.execute" | translate }}
                            </button>
                            <button class="btn btn-sm btn-primary mt-1"
                                    *ngIf="shouldShowGuidedStart(question.content)"
                                    (click)="startStep(question.content)">{{ "ai.agent.actions.start" | translate }}
                            </button>
                          </div>
                        </div>
                        <div class="text text-warning" *ngIf="question.content.error">{{ question.content.error }}</div>
                      </ng-template>
                    </ng-container>
                    <ng-template #typingTemplate>
                      <div class="ai-agent-loop-card ai-agent-loop-card-pending" *ngIf="isPendingQuestion(questionIndex); else legacyTypingTemplate"
                           [attr.data-state]="pendingState === 'executing' ? 'executing' : 'collect_data'">
                        <div class="ai-agent-thinking"
                             role="status"
                             aria-live="polite"
                             [attr.aria-label]="getPendingMessage(questionIndex)">
                          <div class="ai-agent-thinking-track" aria-hidden="true">
                            <span class="ai-agent-thinking-line"></span>
                            <span class="ai-agent-thinking-pulse ai-agent-thinking-pulse--a"></span>
                            <span class="ai-agent-thinking-pulse ai-agent-thinking-pulse--b"></span>
                            <span class="ai-agent-thinking-pulse ai-agent-thinking-pulse--c"></span>
                            <app-ai-agent-avatar class="ai-agent-thinking-avatar"
                                                 [state]="getPendingAvatarState()"
                                                 size="sm"></app-ai-agent-avatar>
                          </div>
                        </div>
                      </div>
                      <ng-template #legacyTypingTemplate>
                        <div class="text typing-animation" *ngIf="isTyping">
                          <div class="ai-agent-thinking"
                               role="status"
                               aria-live="polite"
                               [attr.aria-label]="getPendingMessage(questionIndex)">
                            <div class="ai-agent-thinking-track" aria-hidden="true">
                              <span class="ai-agent-thinking-line"></span>
                              <span class="ai-agent-thinking-pulse ai-agent-thinking-pulse--a"></span>
                              <span class="ai-agent-thinking-pulse ai-agent-thinking-pulse--b"></span>
                              <span class="ai-agent-thinking-pulse ai-agent-thinking-pulse--c"></span>
                              <app-ai-agent-avatar class="ai-agent-thinking-avatar"
                                                   [state]="getPendingAvatarState()"
                                                   size="sm"></app-ai-agent-avatar>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </ng-template>
                    </div>
                  </div>
                  <!--                <div class="photo">-->
                  <!--                  <i class="fa-solid fa-microchip"></i>-->
                  <!--                </div>-->
                </div>
              </ng-container>
            </div>
          </section>
        </div>
      </div>
      <!-- Steps started -->
      <ng-container *ngIf="this.view !== viewMode.HISTORY && (this.agentContent?.actions?.length || 0) > 0 && this.actualStep > 0">
        <div class="card-body">
          <p *ngIf="this.agentContent.actions">{{ this.agentContent.actions[this.actualStep - 1]?.message }}</p>
          <div class="ai-agent-tour-summary" *ngIf="guidedNavigation as navigationTarget">
            <div class="ai-agent-tour-title">{{ navigationTarget.title }}</div>
            <div class="ai-agent-tour-value">{{ navigationTarget.value }}</div>
            <div class="ai-agent-tour-help">{{ navigationTarget.description }}</div>
          </div>
          <div class="ai-agent-tour-summary" *ngIf="getActiveGuidedField() as activeField">
            <div class="ai-agent-tour-progress">{{ getActiveGuidedFieldOrder() }} / {{ getGuidedFieldCount() }}</div>
            <div class="ai-agent-tour-title">{{ activeField.field.name }}</div>
            <div class="ai-agent-tour-value">{{ activeField.field.value }}</div>
          </div>
          <div class="p-0 m-0" *ngIf="guidedFields.length > 0">
            <p>{{ "ai.agent.actions.fields_list.title" | translate }}</p>
            <div class="ai-agent-guided-fields">
              <div class="ai-agent-guided-field"
                   *ngFor="let guidedField of guidedFields; let index = index"
                   [class.active]="isFieldActive(index)">
                <div class="ai-agent-guided-field-copy">
                  <div class="ai-agent-guided-field-name">{{ guidedField.field.name }}</div>
                  <div class="ai-agent-guided-field-value">{{ guidedField.field.value }}</div>
                </div>
                <button class="btn btn-sm btn-outline-primary"
                        type="button"
                        *ngIf="canFillGuidedField(guidedField)"
                        (click)="fillField(guidedField)">
                  {{ "ai.agent.actions.fields_list.fill" | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer d-flex flex-row justify-content-between border-top m-2 p-2"
             *ngIf="hasStepContent()">
          <button class="btn btn-sm btn-outline-secondary" (click)="undo()" [disabled]="this.getChangesSize() === 0 || !!guidedNavigation">
            {{ "ai.agent.actions.undo" | translate }}
          </button>
          <button class="btn btn-sm btn-primary" (click)="previousStep()"
                  [disabled]="!canGoToPreviousStep()">{{ "ai.agent.actions.previous" | translate }}
          </button>
          <button class="btn btn-sm btn-primary" (click)="nextStep()"
                  *ngIf="shouldShowNextStep()">{{ "ai.agent.actions.next" | translate }}
          </button>
          <button class="btn btn-sm btn-primary" (click)="exitStep()">
            {{ "ai.agent.actions.finish" | translate }}
          </button>
        </div>
      </ng-container>

      <div class="card-body" *ngIf="this.view === viewMode.HISTORY">
        <section class="chat" data-tour-id="ai-agent-history">
            <table class="table align-items-center table-flush ai-agent-history-table">
              <tbody>
              <tr *ngFor="let chat of chats">
                <td class="d-table-cell ai-agent-history-cell">
                  <a href="javascript:void(0)" (click)="changeChat(chat)" class="text-truncate ai-agent-history-link">{{ chat.name }}</a>
                </td>
              </tr>
              <tr>
                <th class="d-table-cell text-center"><a href="javascript:void(0)" class="btn btn-sm btn-primary" (click)="changeChat(undefined)">{{ "ai.agent.history.new" | translate }}</a></th>
              </tr>
              </tbody>
            </table>
        </section>
      </div>
    </div>

    <!-- Input -->
    <div class="ai-agent-input-content"
         data-tour-id="ai-agent-composer-dropzone"
         [class.ai-agent-input-content--drag-active]="isAttachmentDragActive"
         (dragover)="onComposerDragOver($event)"
         (dragleave)="onComposerDragLeave($event)"
         (drop)="onComposerDrop($event)">
      <div class="ai-agent-composer" data-tour-id="ai-agent-composer">
        <div class="ai-agent-composer-attachments" data-tour-id="ai-agent-draft-attachments" *ngIf="draftAttachments.length">
          <div class="ai-agent-composer-attachment"
               *ngFor="let attachment of draftAttachments"
               data-tour-id="ai-agent-draft-attachment"
               [class.ai-agent-composer-attachment--rejected]="attachment.state === 'rejected'">
            <div class="ai-agent-composer-attachment__icon">
              <i [class]="getAttachmentIconClass(attachment)" aria-hidden="true"></i>
            </div>
            <div class="ai-agent-composer-attachment__content">
              <div class="ai-agent-composer-attachment__header">
                <span class="ai-agent-composer-attachment__name">{{ attachment.fileName }}</span>
                <span class="ai-agent-composer-attachment__status">
                  {{ 'ai.agent.attachments.status.' + (attachment.state === 'rejected' ? 'rejected' : 'pending') | translate }}
                </span>
              </div>
              <div class="ai-agent-composer-attachment__meta">
                <span>{{ getAttachmentKindLabel(attachment.kind) }}</span>
                <span>•</span>
                <span>{{ formatAttachmentSize(attachment.size) }}</span>
              </div>
              <div class="ai-agent-composer-attachment__message" *ngIf="attachment.message">{{ attachment.message }}</div>
            </div>
            <button type="button"
                    class="ai-agent-composer-attachment__remove"
                    data-tour-id="ai-agent-draft-attachment-remove"
                    (click)="removeDraftAttachment(attachment.id)"
                    [attr.aria-label]="'ai.agent.attachments.remove' | translate">
              <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>
          </div>
        </div>

        <div class="ai-agent-composer__main">
          <button type="button"
                  class="ai-agent-attach-btn"
                  data-tour-id="ai-agent-attach-button"
                  (click)="openAttachmentPicker()"
                  [attr.aria-label]="'ai.agent.attachments.add' | translate">
            <i class="fa-solid fa-paperclip"></i>
          </button>
          <textarea #aiInput
                    class="form-control ai-agent-input"
                    data-tour-id="ai-agent-input"
                    [placeholder]="'ai.agent.attachments.placeholder' | translate"
                    [(ngModel)]="question"
                    (keydown.enter)="$event.preventDefault(); sendQuestion()"
                    (blur)="onInputBlur()"
                    (focus)="onInputFocus()"
                    (paste)="onComposerPaste($event)"
                    autocomplete="off"
                    rows="1"
          ></textarea>
          <input #attachmentInput
                 type="file"
                 class="d-none"
                 data-tour-id="ai-agent-attachment-input"
                 multiple
                 (change)="onAttachmentInputChange($event)">
          <button class="ai-agent-send-btn" data-tour-id="ai-agent-send-button" (click)="sendQuestion()">
            <i class="fa-solid fa-paper-plane"></i>
          </button>
        </div>

      </div>
    </div>
    </ng-container>
  </div>
</ng-container>
